/* eslint-disable import/no-internal-modules */
import React from "react";

import Advanced from "./assets/advanced.svg";
import Core from "./assets/core.svg";
import ForgeBuild from "./assets/forge-build.svg";
import Tooling from "./assets/tooling.svg";
import { SolutionIconImg } from "./styled";
import { SolutionIconProps } from "./types";

export const SolutionIcon: React.FC<SolutionIconProps> = ({
  solutionSlug,
  solutionName,
  ...rest
}) => {
  if (solutionSlug === "advanced" || solutionName === "Advanced Solutions") {
    return (
      <SolutionIconImg
        src={Advanced}
        {...rest}
        alt="Advanced Solutions Icon"
        title="Advanced Solutions"
      />
    );
  }

  if (solutionSlug === "core" || solutionName === "Core Solutions") {
    return (
      <SolutionIconImg
        src={Core}
        {...rest}
        alt="Core Solutions Icon"
        title="Core Solutions"
      />
    );
  }

  if (solutionSlug === "tooling" || solutionName === "Tooling Solutions") {
    return (
      <SolutionIconImg
        src={Tooling}
        {...rest}
        alt="Tooling Solutions Icon"
        title="Tooling Solutions"
      />
    );
  }

  if (solutionSlug === "forge-build" || solutionName === "Forge & Build") {
    return (
      <SolutionIconImg
        src={ForgeBuild}
        {...rest}
        alt="Forge & Build Icon"
        title="Forge & Build"
      />
    );
  }

  console.error(
    `SolutionIcon was called with an invalid slug: ${solutionSlug}`
  );

  return null;
};
